import React from "react";

export default function FilterPanel({ filters, options, onChange, onReset }) {
  return (
    <section className="swb-panel">
      <div className="swb-panel__head">
        <h3>Filtros</h3>
        <button type="button" className="swb-link" onClick={onReset}>
          Limpar
        </button>
      </div>

      <div className="swb-fields-grid">
        <label className="swb-field">
          <span>UP</span>
          <select value={filters.site} onChange={(e) => onChange("site", e.target.value)}>
            <option value="all">Todas</option>
            {(options?.sites || []).map((site) => (
              <option key={site} value={site}>
                {site}
              </option>
            ))}
          </select>
        </label>

        <label className="swb-field">
          <span>Linha</span>
          <select value={filters.line} onChange={(e) => onChange("line", e.target.value)}>
            <option value="all">Todas</option>
            {(options?.lines || []).map((line) => (
              <option key={line} value={line}>
                {line}
              </option>
            ))}
          </select>
        </label>

        <label className="swb-field">
          <span>Risco</span>
          <select
            value={filters.riskLevel}
            onChange={(e) => onChange("riskLevel", e.target.value)}
          >
            <option value="all">Todos</option>
            {(options?.risks || []).map((risk) => (
              <option key={risk} value={risk}>
                {risk}
              </option>
            ))}
          </select>
        </label>

        <label className="swb-field">
          <span>Status</span>
          <select value={filters.status} onChange={(e) => onChange("status", e.target.value)}>
            <option value="all">Todos</option>
            <option value="BATE">BATE</option>
            <option value="NÃO BATE">NÃO BATE</option>
          </select>
        </label>

        <label className="swb-field swb-field--full">
          <span>Buscar máquina / gargalo</span>
          <input
            type="text"
            value={filters.machineQuery}
            onChange={(e) => onChange("machineQuery", e.target.value)}
            placeholder="Ex.: prensa, operadores..."
          />
        </label>

        <label className="swb-check">
          <input
            type="checkbox"
            checked={!!filters.onlyBottlenecks}
            onChange={(e) => onChange("onlyBottlenecks", e.target.checked)}
          />
          <span>Mostrar somente linhas com gargalo principal</span>
        </label>
      </div>
    </section>
  );
}
